import { useInfiniteQuery } from 'react-query';
import { COMPANIES_CACHE_KEY } from '../../Constants';
import { fetchCompanies } from '../../services/company.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (searchText, coverage, csView, sort, filterConfig) => {
  const cacheKeys: string[] = [];

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in filterConfig) {
    cacheKeys.push(filterConfig[key]);
  }

  return useInfiniteQuery<any, Error>([COMPANIES_CACHE_KEY, sort.field, sort.asc, searchText, coverage, csView, ...cacheKeys], async ({ pageParam }) => fetchCompanies(searchText, coverage, csView, sort, cacheKeys, pageParam), {
    getNextPageParam: (lastPage, pages) => pages.length + 1,
  });
};
